import { render, staticRenderFns } from "./RecordedVideoModal.vue?vue&type=template&id=01fdb8f2&scoped=true&"
import script from "./RecordedVideoModal.vue?vue&type=script&lang=js&"
export * from "./RecordedVideoModal.vue?vue&type=script&lang=js&"
import style0 from "./RecordedVideoModal.vue?vue&type=style&index=0&id=01fdb8f2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01fdb8f2",
  null
  
)

export default component.exports